import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { map } from "rxjs/operators";
import { AuthenticationService } from "../authentication.service";
import { AuthorizationService } from "../authorization.service";
import { Permission } from "./permissions.enum";

export function hasPermissionGuard(permission: Permission): CanMatchFn {
  return () => {
    const authorizationService = inject(AuthorizationService);
    const authenticationService = inject(AuthenticationService);
    return authenticationService.currentUser.pipe(
      map(() => {
        return authorizationService.hasPermission(permission);
      })
    );
  };
}
